var path = 'msi/layout/logged-out/logged-out.html';
var html = "<div class=\"og-message-main\" id=\"og-logged-out-message\">\n  <p>{{'LOGGED_OUT' | translate}}</p>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;